export default __webpack_public_path__ + "static/media/paintbrush.93ef7dec.gif";